import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { CircularProgress, TablePagination } from '@mui/material';

function ShopWiseCardandSaleDetailsTable({ month, year, afso_code, dist_code, status, statusValue }) {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    useEffect(() => {
        if (month && year && afso_code) fetchData();
    }, [month, year, afso_code, dist_code, status, statusValue]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_URL_FPS}/api/Fps/getdata`, {
                params: {
                    month: parseInt(month),
                    year: parseInt(year),
                    afsoCode: afso_code,
                    distCode: dist_code,
                    status: parseInt(status),
                    statusValue: parseFloat(statusValue)
                }
            });

            if (response.data.success && response.data.data?.length > 0) {
                setReport(response.data);
            } else {
                // setError("No data found");
            }
        } catch (err) {
            setError("Internal Server Error");
        } finally {
            setLoading(false);
        }
    };

    const formatNumber = (num) => (num ? Number(num).toLocaleString("en-IN") : "0");

    if (loading) return <div align="center"><CircularProgress /></div>;
    if (error) return <div align="center" style={{ color: "red" }}><p className='response'>{error}</p></div>;
    if (!report?.data?.length) return <div align="center"><p className='response'>No data found</p></div>;

    const data = report.data;
    const filteredData = data;     

    const currentRows = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const schemes = Object.keys(data[0].total_cards || {}).filter(k => k !== 'total');
    const commodities = Object.keys(data[0].quantity_sold || {});
    const totalCards = schemes.reduce((acc, s) => ({ ...acc, [s]: data.reduce((sum, r) => sum + (r.total_cards[s] || 0), 0) }), {});
    const totalAvail = schemes.reduce((acc, s) => ({ ...acc, [s]: data.reduce((sum, r) => sum + (r.avail_cards[s] || 0), 0) }), {});
    const grandTotalCards = data.reduce((sum, r) => sum + r.total_cards.total, 0);
    const grandTotalunits = data.reduce((sum, r) => sum + r.total_units.total, 0);
    const grandAvailCards = data.reduce((sum, r) => sum + r.avail_cards.total, 0);
    const avgPercent = data.length > 0 ? (data.reduce((sum, r) => sum + (r.avail_per || 0), 0) / data.length).toFixed(2) + "%" : "0%";

    return (
        <div>
            <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 20, 50, 100]}
            />
            <table width='100%'>
  <tr className="tableheader">
    <th colSpan={10} style={{ textAlign: 'center' }}>
      {report.tableheading}
    </th>
  </tr>
</table>
            <div align="center" style={{
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '700px',
                maxWidth: '100%',
                margin: '0 auto'
            }}>
                <table >
                    <thead style={{
                        position: 'sticky',
                        top: 0,
                        background: '#fff',
                        zIndex: 10
                    }}>
                        
                        <tr className="tableheader">
                            <th rowSpan={3}>S.No</th>
                            <th rowSpan={3}>District</th>
                            <th rowSpan={3}>Office</th>
                            <th rowSpan={3}>FPS ID</th>
                            <th rowSpan={3}>Active Days</th>
                            <th colSpan={2+schemes.length * 2} >Total Cards & Units</th>
                            <th colSpan={schemes.length + 1} rowSpan={2}>Avail Cards</th>
                            <th rowSpan={3}>Distribution %(avail/total cards)</th>
                            <th colSpan={commodities.reduce((sum, c) => sum + Object.keys(data[0].quantity_sold[c] || {}).length, 0)}>
                                Quantity Sold (in Kg)
                            </th>
                        </tr>
                        <tr className="tableheader">
                            {schemes.map(s => <th colSpan={2}>{s.toUpperCase()}</th>)}
                            <th colSpan={2} >TOTAL</th>

                            {commodities.map(comm => (
                                <th colSpan={Object.keys(data[0].quantity_sold[comm] || {}).length}>
                                    {comm.replace(/_/g, " ").toUpperCase()}
                                </th>
                            ))}
                        </tr>
                        <tr className="tableheader">
                            {schemes.map((_, i) => (
                                <>
                                    <th>Cards</th>
                                    <th>Units</th>
                                </>
                            ))}
                            <th>Cards</th>
                            <th>Units</th>
                            {schemes.map(s => <th>{s.toUpperCase()}</th>)}
                            <th>TOTAL</th>
                            {commodities.map(comm => {
                                const schemeKeys = Object.keys(data[0].quantity_sold[comm] || {})
                                    .filter(k => k !== 'total')
                                    .sort();
                                return (
                                    <>
                                        {schemeKeys.map(s => <th>{s.toUpperCase()}</th>)}
                                        <th>TOTAL</th>
                                    </>
                                );
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        {currentRows.map((row, idx) => (
                            <tr key={idx}>
                                <td>{page * rowsPerPage + idx + 1}</td>
                                <td>{row.dist_name_en}</td>
                                <td>{row.afso_name_en}</td>
                                <td>{row.fps_id}</td>
                                <td align='right'>{row.login_days}</td>
                                {schemes.map(s => (
                                    <>
                                        <td align='right'>{formatNumber(row.total_cards[s])}</td>
                                        <td align='right'>{formatNumber(row.total_units[s] || 0)}</td>
                                    </>
                                ))}
                                 <td align='right'>{formatNumber(row.total_cards.total)}</td>
                                <td align='right'>{formatNumber(row.total_units.total)}</td>
                                {schemes.map(s => <td align='right'>{formatNumber(row.avail_cards[s])}</td>)}
                                <td align='right'>{formatNumber(row.avail_cards.total)}</td>
                                <td align='right'>{Number(row.avail_per || 0).toFixed(2)}%</td>
                                {commodities.map(comm => {
                                    const c = row.quantity_sold[comm] || {};
                                    const keys = Object.keys(c).filter(k => k !== 'total').sort();
                                    return (
                                        < >
                                            {keys.map(s => <td align='right'>{formatNumber(c[s] || 0)}</td>)}
                                            <td align='right'>{formatNumber(c.total || 0)}</td>
                                        </>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>

                    <tfoot>
                        <tr className="tableheader">
                            <td colSpan={5} align="center"><strong>TOTAL</strong></td>
                            {schemes.map(s => (
                                <>
                                    <td>{formatNumber(totalCards[s] || 0)}</td>
                                    <td>{formatNumber(data.reduce((sum, r) => sum + (r.total_units?.[s] || 0), 0))}</td>
                                </>
                            ))}
                            <td >{formatNumber(grandTotalCards)}</td>
                                                        <td >{formatNumber(grandTotalunits)}</td>

                            {schemes.map(s => (
                                <td >{formatNumber(totalAvail[s] || 0)} </td>
                            ))}
                            <td >{formatNumber(grandAvailCards)}</td>
                            <td >{avgPercent}</td>
                            {commodities.map(comm => {
                                const cTotals = {};
                                const keys = Object.keys(data[0].quantity_sold[comm] || {}).filter(k => k !== 'total');
                                keys.forEach(s => {
                                    cTotals[s] = data.reduce((sum, r) => sum + (r.quantity_sold[comm]?.[s] || 0), 0);
                                });
                                const totalQty = Object.values(cTotals).reduce((a, b) => a + b, 0);
                                return (
                                    <>
                                        {keys.sort().map(s => (
                                            <td >{formatNumber(cTotals[s])}</td>
                                        ))}
                                        <td >{formatNumber(totalQty)}</td>
                                    </>
                                );
                            })}
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div style={{ marginTop: "20px" }}>

            </div>

            <br></br>
            <br></br>
            <br></br>


        </div>
    );
}

export default ShopWiseCardandSaleDetailsTable;